import React from 'react'
import { Redirect } from 'react-router-dom'
import styles from './NotFound.styl'

export default class NotFound extends React.Component {

	render() {
		return (
			<div>
				<div className={ styles['content'] }>
					<h1>Not found!! :(</h1>
					<Redirect to="/not_found" />
				</div>
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/client/NotFound/NotFound.js